import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

const AdminDashboard = () => {
  const { t } = useLanguage();

  return (
    <Container className="py-5">
      <h1 className="mb-4">{t('admin.dashboard')}</h1>
      
      <Row xs={1} md={2} lg={3} className="g-4">
        <Col>
          <Card className="h-100">
            <Card.Body className="text-center">
              <h3>{t('admin.products')}</h3>
              <p>{t('admin.manageProductsDesc')}</p>
              <Button as={Link} to="/admin/products" variant="primary">
                {t('admin.products')}
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <Card className="h-100">
            <Card.Body className="text-center">
              <h3>{t('admin.catalogTab')}</h3>
              <p>{t('admin.manageCatalogDesc')}</p>
              <Button as={Link} to="/admin/products?tab=catalog" variant="primary">
                {t('admin.catalogTab')}
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <Card className="h-100">
            <Card.Body className="text-center">
              <h3>{t('admin.categories')}</h3>
              <p>{t('admin.manageCategoriesDesc')}</p>
              <Button as={Link} to="/admin/categories" variant="primary">
                {t('admin.manageCategories')}
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <Card className="h-100">
            <Card.Body className="text-center">
              <h3>{t('admin.orders')}</h3>
              <p>{t('admin.manageOrdersDesc')}</p>
              <Button as={Link} to="/admin/orders" variant="primary">
                {t('admin.viewOrders')}
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <Card className="h-100">
            <Card.Body className="text-center">
              <h3>{t('admin.users')}</h3>
              <p>{t('admin.manageUsersDesc')}</p>
              <Button as={Link} to="/admin/users" variant="primary">
                {t('admin.manageUsers')}
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <Card className="h-100">
            <Card.Body className="text-center">
              <h3>Companies</h3>
              <p>Manage companies and their details</p>
              <Button as={Link} to="/admin/companies" variant="primary">
                Manage Companies
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <Card className="h-100">
            <Card.Body className="text-center">
              <h3>{t('admin.settings')}</h3>
              <p>{t('admin.manageSettingsDesc')}</p>
              <Button as={Link} to="/admin/settings" variant="primary">
                {t('admin.settings')}
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <Card className="h-100">
            <Card.Body className="text-center">
              <h3>{t('admin.manageBranding')}</h3>
              <p>{t('admin.manageBrandingDesc')}</p>
              <Button as={Link} to="/admin/branding" variant="primary">
                {t('admin.manageBranding')}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminDashboard;
